import React from 'react'
import MainLayout from '@toasttab/shared/src/layout/MainLayout'
import Footnotes from '@toasttab/shared/src/components/organisms/Footnotes/Footnotes'
import {
  PageContextProps,
  PageContextProvider
} from '@toasttab/shared/src/hooks/usePageContext'
import _helpers from '@toasttab/shared/src/globals/_helpers'
import SnowflakeRenderer from '@toasttab/main/src/utils/SnowflakeRenderer'
import { graphql } from 'gatsby'

export const query = graphql`
  query ($locale: String!, $region: String!, $slug: String!) {
    allContentfulMdsSnowflakePage(
      filter: {
        node_locale: { eq: $locale }
        regions: { elemMatch: { country: { eq: $region } } }
        slug: { eq: $slug }
      }
    ) {
      edges {
        node {
          title
          slug
          regions {
            ... on ContentfulMdsSnowflakeRegion {
              ...SnowflakeRegion
              nt_experiences {
                ...NT_SnowflakeRegion
              }
            }
          }
          footerOverride {
            pageFooter {
              country
              ...FooterContent
            }
          }
          __typename
          contentful_id
          id: contentful_id
        }
      }
    }
    site {
      siteMetadata {
        twitterUsername
        title
        siteUrl
        hostName
        pathPrefix
        image
        description
      }
    }
    allContentfulGlobalPageFooter(filter: { node_locale: { eq: $locale } }) {
      edges {
        node {
          internalName
          pageFooter {
            country
            ...FooterContent
          }
        }
      }
    }
    allContentfulMicrocopy(filter: { node_locale: { eq: $locale } }) {
      edges {
        node {
          key
          content
        }
      }
    }
    allContentfulGlobalSettings(filter: { node_locale: { eq: $locale } }) {
      edges {
        node {
          globalBanner {
            ...GlobalBanner
          }
        }
      }
    }
  }
`

const HomepageRegion = (props: any) => {
  const { disclaimers, footerContent, localizedEntries, siteId, siteMetadata } =
    props.context

  const context: PageContextProps = {
    ...props.context
  }

  const refContent = props?.referencedContent

  return (
    <PageContextProvider value={context}>
      <MainLayout
        footerContent={footerContent}
        localizedEntries={localizedEntries}
        packageName='main'
        siteId={siteId}
        siteMetadata={siteMetadata}
      >
        {Array.isArray(refContent) && refContent.length > 0
          ? SnowflakeRenderer(refContent)
          : null}
        {disclaimers ? <Footnotes footnotes={disclaimers} /> : null}
      </MainLayout>
    </PageContextProvider>
  )
}

export default HomepageRegion
